'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.beginningOfYear;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/beginningOfYear.js
// module id = 256
// module chunks = 0